import React, { useState } from 'react';
import { connect } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PDFIcon from '@material-ui/icons/PictureAsPdf';
import { FormattedMessage } from 'react-intl';
import PDFExportDialog from './PDFExportDialog';

const PDFExportMenuItem = (props) => {
	const [open, setOpen] = useState(false);
	const showDialog = (doIt) => (ev) => {
		ev.stopPropagation();
		setOpen(doIt);
	};

	return (
		<MenuItem dense onClick={showDialog(true)}>
			<ListItemIcon>
				<PDFIcon fontSize="default" />
			</ListItemIcon>
			<ListItemText
				primary={<FormattedMessage id="Extensions.PDF.Tooltip.GeneratePDF" defaultMessage="Export PDF" />}
			/>
			<PDFExportDialog open={open} onClose={showDialog(false)} filename={props.machineName} />
		</MenuItem>
	);
};

function mapStateToProps(state) {
	return {
		machineName: state.monitor.machine.name
	};
}

export default connect(mapStateToProps)(PDFExportMenuItem);



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/pdf/PDFExportMenuItem.js